'use strict';
export default function ObjectsController(
  $translate,
  $scope,
  $rootScope,
  $stateParams,
  $window,
  $uibModal,
  objectsService,
  NotificationService,
  UtilService,
  OC_API,
) {
  const vm = this;
  let tempObjectId = 1;

  vm.isLoading = false;
  vm.merchantId = $stateParams.merchantId;
  vm.area = $scope.area;
  vm.objects = [];
  vm.originalObjects = [];
  vm.newObject = {};
  vm.objectTypes = $scope.objectTypes;
  vm.defaultObjectType = null;
  vm.selectAllObjects = false;
  vm.selectedObjects = {};
  vm.atLeastOneSelected = false;
  vm.modalInstance = null;

  vm.init = init;
  vm.addObject = addObject;
  vm.saveObjects = saveObjects;
  vm.deleteObjects = deleteObjects;
  vm.removeNewObject = removeNewObject;
  vm.prefillObjectTypeData = prefillObjectTypeData;
  vm.updateSelectedObjects = updateSelectedObjects;
  vm.updateSelectAllCheckbox = updateSelectAllCheckbox;
  vm.onBlockTablesClick = onBlockTablesClick;
  vm.onUnblockTablesClick = onUnblockTablesClick;

  const listener = $scope.$on('merchant.tab.area-' + vm.area.id + '.loaded', vm.init);

  vm.init();

  function init() {
    listener();
    if (!vm.objectTypes) {
      getObjectTypes();
    }
    setDefaultObjectType();
    getObjects();
  }

  function getObjectTypes() {
    enableLoading();
    objectsService
      .getObjectTypes()
      .then(function(res) {
        vm.objectTypes = res.data.objectTypes;
      })
      .catch(function() {
        NotificationService.error('Error getting table types');
      })
      .finally(disableLoading);
  }

  function setDefaultObjectType() {
    vm.defaultObjectType = null;
    angular.forEach(vm.objectTypes, function(objectType) {
      if (objectType.default) {
        vm.defaultObjectType = {
          id: objectType.id,
        };
      }
    });
  }

  function addObject() {
    var newObject = {
      id: 'tempId' + tempObjectId++,
      isNewObject: true,
      bookingPriority: 1,
      x: 0,
      y: 0,
      rotation: 0,
      type: angular.copy(vm.defaultObjectType),
    };
    if (vm.area.overbookingEnabled) {
      newObject.overBookable = true;
    }
    prefillObjectTypeData(newObject);
    vm.objects.push(newObject);
  }

  function getObjects() {
    enableLoading();
    objectsService
      .getObjects(vm.merchantId, vm.area.id)
      .then(initObjects)
      .catch(function() {
        NotificationService.error('Error getting merchant tables');
      })
      .finally(disableLoading);
  }

  function initObjects(res) {
    if (res.data && res.data.objects) {
      vm.objects = res.data.objects;
      vm.originalObjects = angular.copy(vm.objects);
      vm.selectedObjects = {};
      vm.selectAllObjects = false;
      vm.deleteEnabled = false;
    }
  }

  function deleteObjects() {
    if (vm.isLoading) {
      return;
    }
    if ($window.confirm('Are you sure you want to delete the selected table(s)?')) {
      enableLoading();
      objectsService
        .deleteObjects(vm.merchantId, vm.area.id, getSelectedObjectIds())
        .then(function() {
          getObjects();
          NotificationService.success('Merchant table(s) deleted');
          $rootScope.$broadcast('merchant.objects.updated');
          checkIfAtLeastOneSelected();
        })
        .catch(function(res) {
          var error = angular.isArray(res.data.errors) ? res.data.errors.shift() : res.data.errors,
            errorMessage = error.message ? $translate.instant(error.message) + ' - ' + error.field : 'Error deleting merchant table(s)';
          NotificationService.error(errorMessage);
        })
        .finally(disableLoading);
    }
  }

  function updateSelectAllCheckbox() {
    vm.selectAllObjects = !vm.objects.some(object => !vm.selectedObjects[object.id]);
    checkIfAtLeastOneSelected();
  }

  function updateSelectedObjects() {
    if (vm.selectAllObjects) {
      vm.objects.forEach(object => {
        vm.selectedObjects[object.id] = true;
      });
    } else {
      vm.selectedObjects = {};
    }

    checkIfAtLeastOneSelected();
  }

  function checkIfAtLeastOneSelected() {
    vm.atLeastOneSelected = Object.keys(vm.selectedObjects).some(key => vm.selectedObjects[key]);
  }

  function removeNewObject(id) {
    vm.objects = vm.objects.filter(function(object) {
      return object.id !== id;
    });
  }

  function saveObjects() {
    var data, changedObjects;
    if (vm.isLoading) {
      return;
    }
    changedObjects = getChangedObjects();
    if (changedObjects.length === 0) {
      return;
    }
    enableLoading();
    data = {
      objects: prepareForUpdate(changedObjects),
    };
    objectsService
      .updateObjects(vm.merchantId, vm.area.id, data)
      .then(initObjects)
      .then(function() {
        NotificationService.success('Table data successfully updated');
        $rootScope.$broadcast('merchant.objects.updated');
      })
      .catch(function(res) {
        var error = angular.isArray(res.data.errors) ? res.data.errors.shift() : res.data.errors,
          errorMessage = error.message ? $translate.instant(error.message) : 'Error updating table data';
        NotificationService.error(errorMessage);
      })
      .finally(disableLoading);
  }

  function getChangedObjects() {
    var changedObjects = angular.copy(vm.objects);
    return changedObjects.filter(function(object) {
      var originalObject = UtilService.findElementById(vm.originalObjects, object.id);
      return !angular.equals(originalObject, object);
    });
  }

  function prepareForUpdate(objects) {
    return objects.map(function(object) {
      if (object.isNewObject) {
        object.id = null;
        delete object.isNewObject;
      }
      return object;
    });
  }

  function prefillObjectTypeData(object) {
    angular.forEach(vm.objectTypes, function(objectType) {
      if (objectType.id === object.type.id) {
        object.minCapacity = objectType.minCapacity;
        object.maxCapacity = objectType.maxCapacity;
        object.width = objectType.width;
        object.length = objectType.length;
        object.isAvailableOnline = true;
      }
    });
  }

  function getSelectedObjectIds() {
    return Object.keys(vm.selectedObjects).filter(key => vm.selectedObjects[key]).map(key => parseInt(key, 10));
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }

  function onBlockTablesClick() {
    vm.modalInstance = $uibModal
      .open({
        template: '<app-block-tables-modal></app-block-tables-modal>',
        size: 'md',
        animation: true,
        backdrop: 'static',
        keyboard: false,
        controller: ($scope, $uibModalInstance) => {
          $scope.isBlock = true;
          $scope.onConfirm = (dates) => blockTables(dates, $uibModalInstance, $scope);
          $scope.onCancel = () => $uibModalInstance.dismiss();
        },
      });
  }

  function onUnblockTablesClick() {
    vm.modalInstance = $uibModal
      .open({
        template: '<app-block-tables-modal></app-block-tables-modal>',
        size: 'md',
        animation: true,
        backdrop: 'static',
        keyboard: false,
        controller: ($scope, $uibModalInstance) => {
          $scope.isBlock = false;
          $scope.onConfirm = () => unblockTables($uibModalInstance, $scope);
          $scope.onCancel = () => $uibModalInstance.dismiss();
        },
      });
  }

  function blockTables(dates, modalInstance, scope) {
    scope.isLoading = true;

    const data = getData(dates);

    objectsService.blockTables(vm.merchantId, data)
      .then(() => handleSuccess('Tables were successfully blocked', modalInstance))
      .catch(() => scope.isLoading = false);
  }

  function unblockTables(modalInstance, scope) {
    scope.isLoading = true;

    const data = getData();

    objectsService.unblockTables(vm.merchantId, data)
      .then(() => handleSuccess('Tables were successfully unblocked', modalInstance))
      .catch(() => scope.isLoading = false);
  }

  function handleSuccess(message, modalInstance) {
    NotificationService.success(message);
    modalInstance.close();
    vm.selectedObjects = {};
    vm.selectAllObjects = false;
    checkIfAtLeastOneSelected();
  }

  function getData(dates) {
    const start = dates && dates.start ? moment(dates.start) : moment();
    const end = dates && dates.end ? moment(dates.end) : null;

    return {
      start: start.format(OC_API.JUST_DATE_FORMAT),
      end: end ? end.format(OC_API.JUST_DATE_FORMAT) : null,
      objectIds: getSelectedObjectIds(),
    };

  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/areas/objects.controller.js